import React from 'react'
import makeStyles from '@material-ui/core/styles/makeStyles'
import AppCard from 'components/app-card'
import headerImage from 'images/landing-pga-coach-header.png'
import logo from 'images/pga-coach-logo.svg'

const useStyles = makeStyles({
  brandLogo: {
    display: 'block',
    height: 32,
    width: 'auto',
  },
})

export default function PgaCoach() {
  const classes = useStyles()

  return (
    <AppCard
      title="Manage students, lessons, and your coaching business."
      to="/pga-coach"
      buttonText="Open PGA Coach"
      testid="pga-coach-tile"
      headerImage={headerImage}
      headerImageAlt="PGA Coaches collaborating with coaching technology"
      headerImagePosition="center 30%"
      brand={<img src={logo} alt="PGA Coach" className={classes.brandLogo} />}
    />
  )
}
